<template>
  <Stage>
    <InstructionsContainer>
      <section class="gng-body">
        <h1>{{ headerText }}</h1>
        <p>{{ headerBody }}</p>
        <FeatureImage
          v-if="image"
          :src="this.image"
          :imageCache="imageCache"
          :alt="`logo for ${headerText} exam`"
        />
      </section>
    </InstructionsContainer>

    <Button
      v-if="buttonIsNavigation"
      :label="buttonText"
      @click="$emit('next')"
    />
    <Button v-else disable-mouse :label="buttonText" />
  </Stage>
</template>
<script>
import { Button, Stage } from '@neurotrack/web-shared-components'
import essComponentProps from '@/mixins/essComponentProps'
import FeatureImage from '@/components/FeatureImage'
import InstructionsContainer from '@/components/InstructionsContainer'

export default {
  name: 'instructions_header_image_one_button',
  components: {
    Button, Stage, FeatureImage, InstructionsContainer
  },
  mixins: [essComponentProps],
  computed: {
    headerText() {
      return this.trialData?.header?.headline?.text ?? 'No Header'
    },
    headerBody() {
      return this.trialData?.header?.content?.text ?? 'No body'
    },
    image() {
      return this.trialData?.body?.image?.filename
    },
    buttonIsNavigation() {
      return this.trialData?.footer?.button?.action === 'next'
    },
    buttonText() {
      return this.trialData?.footer?.button?.text
    }
  }
}
</script>

<style scoped>
img {
  width: 300px;
  height: 300px;
}
p {
  text-align: center;
}

.gng-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* why is this defined at the instance level? */
.instructions-container {
  display: flex;
  align-items: center;
}
</style>
